import * as React from 'react';
import { alpha, Box, CircularProgress } from '@mui/material';

import palette from 'ui/theme/palette';

interface SpinnerProps {
  text?: string;
  dataCy?: string;
  dataCyText?: string;
}

export const Spinner: React.FC<SpinnerProps> = (props) => {
  return (
    <Box
      sx={{
        justifyContent: 'center',
        flexDirection: 'column',
        minHeight: '80px',
        display: 'flex',
        width: '100%'
      }}
    >
      <Box sx={{ margin: '0 auto' }}>
        <Box
          sx={{
            position: 'relative'
          }}
        >
          <CircularProgress
            variant="determinate"
            sx={{
              color: alpha(palette.primary.main, 0.3),
              position: 'absolute',
              marginLeft: '-20px'
            }}
            size="40px"
            value={100}
          />

          <CircularProgress
            color="primary"
            sx={{ position: 'absolute', marginLeft: '-20px' }}
            data-cy={props.dataCy ? props.dataCy : 'loading-spinner'}
            size="40px"
          />
        </Box>
      </Box>

      {props.text ? (
        <div
          style={{
            width: 'fit-content',
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '20px',
            color: '#828599',
            textAlign: 'center',
            margin: '0 auto',
            marginTop: '55px'
          }}
          data-cy={props.dataCyText}
        >
          {props.text}
        </div>
      ) : null}
    </Box>
  );
};
